<template>
  <div class="p-lg pb-leftSquiggleHeight">
    <h1>Contact Autocomplete</h1>

    <p>Selected contact:</p>

    <pre>{{ selectedContact }}</pre>

    <ContactAutocomplete
      v-model="name"
      @selected="handleSelection"
    />
    </div>
</template>

<script setup>

import ContactAutocomplete from '@/components/ui/contacts/ContactAutocomplete/ContactAutocomplete.vue';
import { ref } from 'vue';

const name = ref('');
const selectedContact = ref();

function handleSelection(event) {
  selectedContact.value = event;
  if (event) {
    name.value = event.title;
  } else {
    name.value = '';
  }
}

</script>
